// extracted by mini-css-extract-plugin
export var cardContainer = "_mk-0";
export var cardHeader = "_mk-2";
export var collapsedState = "_mk-3";
export var dragHandle = "_mk-5";
export var dragHandleIcon = "_mk-6";
export var dragging = "_mk-1";
export var titleArea = "_mk-4";